import { ErrorMessageWrapper } from '@/common/components/ErrorMessageWrapper'
import { UnknownErrorMessage } from '@/common/components/UnknownErrorMessage'
import MaintenanceWorkflowForwardingShowLoading from '@/features/maintenanceWorkflow/pages/Show/components/tabs/ForwardingsTabs/MaintenanceWorkflowForwardingShowLoading'
import { maintenanceForwardingsDirectiveEntryKlasses } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsDirectiveEntryKlasses.constant'
import { MaintenanceForwardingsDirectiveEntryKlass } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsDirectiveEntryKlasses.type'
import { useMaintenanceForwarding } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/hooks/useMaintenanceForwarding'
import { ForwardingTabContext } from '@/features/maintenanceWorkflow/pages/Show/hooks/forwardings/useForwardingTabContext'
import { MaintenanceWorkflowData } from '@/features/maintenanceWorkflow/types/maintenanceWorkflows.type'
import { useMemo } from 'react'

interface MaintenanceWorkflowForwardingShowProps {
  workflow: MaintenanceWorkflowData | undefined
  forwardingId: string
  directiveEntryKlass: MaintenanceForwardingsDirectiveEntryKlass
  noActions?: boolean;
}

const MaintenanceWorkflowForwardingShow = ({
  workflow,
  forwardingId,
  directiveEntryKlass,
  noActions,
}: MaintenanceWorkflowForwardingShowProps) => {
  const {
    data: forwarding,
    isPending: forwardingIsPending,
    error: forwardingError = {} as any,
    refetch: refetchForwarding,
    dataUpdatedAt: forwardingUpdatedAt,
  } = useMaintenanceForwarding(forwardingId)

  const ForwardingStateComponent = useMemo(() => {
    const maintenanceDirectiveEntryData = maintenanceForwardingsDirectiveEntryKlasses[directiveEntryKlass]

    if (!maintenanceDirectiveEntryData) {
      return false
    }

    const directiveEntryStatusData = forwarding?.status && maintenanceDirectiveEntryData.status[forwarding.status]

    if (!directiveEntryStatusData) {
      return false
    }

    return directiveEntryStatusData.component || false
  }, [directiveEntryKlass, forwarding?.status])

  if (forwardingIsPending) {
    return <MaintenanceWorkflowForwardingShowLoading />
  }

  return (
    <ErrorMessageWrapper className="flex-1" statusCode={forwardingError?.status} refetchFunction={refetchForwarding}>
      {forwarding && ForwardingStateComponent && (
        <ForwardingTabContext.Provider
          value={{
            workflow,
            forwarding,
            forwardingUpdatedAt,
            directiveEntryKlass,
            noActions,
          }}
        >
          <div className="flex-1 overflow-auto flex flex-col gap-4">
            <ForwardingStateComponent />
          </div>
        </ForwardingTabContext.Provider>
      )}

      {(!forwarding || !ForwardingStateComponent) && <UnknownErrorMessage className="flex-1" />}
    </ErrorMessageWrapper>
  )
}

export default MaintenanceWorkflowForwardingShow
